import s from './SoundPlayer.module.css';
import {Image} from 'react-bootstrap';
import musicPlayer from'../asset/music-player.png';

export function SoundPlayer({soundFile}) {
    var savingCurrencySound = soundFile;
    var playCurrencySound = () => {     
			if (!soundFile) {
				return;
			}
			var audio = new Audio(savingCurrencySound);
			audio.play();
    }
    return (
			<Image className={s.musicPlayer} fluid onClick={ () => playCurrencySound() }
				src={musicPlayer} rounded />
		
    );
}
	